import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, booleanAttribute, computed, input, signal } from '@angular/core';

import { overrideImageUrl } from '../../image/image-url-provider';

export class ImageStyles {
    gameTileBorderRadius: string | undefined;
}

@Component({
    selector: 'cs-image-loader',
    templateUrl: './image-loader.component.html',
    styleUrl: './image-loader.component.scss',
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageLoaderComponent {
    @Input({ transform: booleanAttribute }) isLegacy = true;
    @Input({ transform: booleanAttribute }) disableLazyLoading = true;
    @Input() defaultSrc: string;

    readonly src = input.required<string>();
    readonly icon = input.required<ImageStyles>();
    readonly isBlockModuleVersion = input<boolean>(false);

    isImageLoaded = signal(false);

    computedStyle = computed(() => this.getComputedStyle(this.icon()));
    optimizedUrl = computed(() => overrideImageUrl({ src: this.src() }));

    onImageLoaded() {
        this.isImageLoaded.set(true);
    }

    getComputedStyle(icon: ImageStyles) {
        return this.isImageLoaded()
            ? `border-radius: ${icon.gameTileBorderRadius}; background-color: 'unset'`
            : `border-radius: ${icon.gameTileBorderRadius};`;
    }
}
